import React from "react";
import utils from "shared/lib/utils";

export default (props) => {

  const { src, style } = props;

  const imageStyles = {
    ...style,
    backgroundImage: utils.url(src)
  };

  return src && <div style={imageStyles} />;
}
